module.exports = __webpack_public_path__ + "img/behold-3.68debc7d.png";